import styled from "styled-components";

export const MissionInfoRowStyled = styled.div`
  .top_row {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 12px;
    flex-wrap: wrap;
  }

  .label_th {
    font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    color: ${({ theme }) => theme.COLORS.GRAY_23};
  }

  .label_en {
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
  }

  .value_prefix{
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
  }
  .value_unit {
    display: flex;
    align-items: baseline;
    gap: 6px;
    flex-shrink: 0;
    
  }

  .value {
    font-family: ${({ theme }) => theme.FONT.STYLE.SEMIBOLD};
    font-size: ${({ theme }) => theme.FONT.SIZE.S24};
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
  }

  .unit {
    font-family: ${({ theme }) => theme.FONT.STYLE.MEDIUM};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    color: ${({ theme }) => theme.COLORS.GRAY_26};
  }
`;
